import type { KpiCardSpec } from './card-spec';

/**
 * The Churn rate scalar, shown on the Users page's Retention pulse section
 * and the Retention & Health page's Retention breakdown. One object in two
 * catalogs, so the two pages cannot report different figures for the same KPI.
 */
export const CHURN_RATE_SCALAR_CARD: KpiCardSpec = {
    title: 'Churn rate',
    source: 'churn',
    metric: 'churnRate',
    form: 'rate',
    size: 'sm',
    description:
        'Account deletions minus swaps, floored at zero, over the users who signed up in the selected period. The two halves count different populations: the numerator is bounded on the deletion date and the denominator on the signup date, so this is not a cohort. It is not capped at 100% either, and legitimately reads above it when a period sees more deletions than signups.',
};
